"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 6h-1V3c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2M8 3h8v3H8zm4 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12.5 13.79V12c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2c0 .13.05.26.15.35l1.14 1.14c.2.2.51.2.71 0s.2-.51 0-.71z"
}, "1")], 'PunchClockRounded');